import { render, staticRenderFns } from "./pagination-buttons.vue?vue&type=template&id=6a2dce9e&scoped=true"
import script from "./pagination-buttons.vue?vue&type=script&lang=js"
export * from "./pagination-buttons.vue?vue&type=script&lang=js"
import style0 from "./pagination-buttons.vue?vue&type=style&index=0&id=6a2dce9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2dce9e",
  null
  
)

export default component.exports